import React from 'react';
import styled from 'styled-components';
import {FormLabel} from '../form-features/labels/FormLabel';
import {WordFix} from '../form-features/labels/WordFix';
import {FormGroup} from '../form-features/form-group/FormGroup';
import {fileTypeInput, formSubDetailSetup, insideFormElementSetup} from '../form-mixin/formElementSetup';
import {formDirection} from '../form-mixin/formDirection';
import {FormIconLabel} from '../form-features/labels/FormIconLabel';
import {containerSuffix} from '../form-conditions/conditionSuffix';
import {innecontainerPrefix} from '../form-conditions/conditionPrefix';
import {formControlFocus} from '../form-mixin/formControlFocus';
import {colorTheme} from '../../mixin/colorTheme';

export const FormControlStructure = ({
    name,
    disabled,
    label,
    prefix,
    suffix,
    direction,
    children,
    styleFile,
    errorMessage,
    nonePrefix,
    icon,
}) => (
    <FormControlWrapper
        nonePrefix={nonePrefix}
        styleFile={styleFile}
        disabled={disabled}
        direction={direction}
        prefix={prefix}
        suffix={suffix}>
        {(label || icon) && (
            <FormLabel htmlFor={name}>
                {label}
                {icon && (
                    <FormIconLabel name={icon.icon} color={icon.color}>
                        {icon.tooltip}
                    </FormIconLabel>
                )}
            </FormLabel>
        )}
        <div>
            {prefix && <WordFix htmlFor={name}>{prefix}</WordFix>}
            {children}
            {suffix && <WordFix htmlFor={name}>{suffix}</WordFix>}
        </div>
        {errorMessage && <>{errorMessage}</>}
    </FormControlWrapper>
);

export const FormControlWrapper = styled(FormGroup)`
    ${colorTheme({
        '--datepicker-select-background-hover   ': {dark: 'var(--primary)   ', light: 'var(--primary)'},
        '--datepicker-select-text-hover        ': {dark: 'var(--white-00)  ', light: 'var(--white-00)'},
    })};
    input,
    select,
    textarea {
        ${insideFormElementSetup}
        outline: none!important;
        color: var(--default-text-color);
        border-radius: var(--form-input-radius);

        &:-ms-input-placeholder {
            color: var(--label-text-color);
        }
        &::-webkit-input-placeholder {
            color: var(--label-text-color);
        }
        &::placeholder {
            color: var(--label-text-color);
        }
    }

    ${formControlFocus};

    ${({disabled}) => {
        if (!disabled) return null;
        else
            return `
                cursor: not-allowed;
                *{cursor: not-allowed!important;}




                ${WordFix} {
                    background: var(--container-background-color-disabled-200);
                    border-color: var(--container-border-color-100);
                    color: var(--label-text-color);
                }
            `;
    }}

    ${({styleFile}) => fileTypeInput(styleFile)};
    ${({direction}) => formDirection(direction)};
    ${({type}) => formSubDetailSetup(type)};

    ${({suffix}) => containerSuffix(suffix)};
    ${({prefix}) => innecontainerPrefix(prefix)};
`;
